import VueRouter from 'vue-router'
import routes from './routes'
import store from '../store'
import Vue from 'vue'
Vue.use(VueRouter)

// mode: 'history',
const Router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes
})
var startTime = Date.now()
// This callback runs before every route change, including on page load.
Router.beforeEach((to, from, next) => {
  // Loading.show({ delay: 10 })
  if (
    (to.query.back === true || from.query.back !== true) &&
    (to.query.back !== true || from.query.back === true) &&
    store.state.askToLeave
  ) {
    if (!confirm('Si continua perderá los cambios.')) {
      return next(false)
    }
    store.dispatch('AskToLeave', false)
  }
  setTimeout(() => {
    store.dispatch('setInnerLoading', true)
  }, 10)
  startTime = Date.now()
  let _currentUser = store.getters.isAuthenticated || store.getters.authStatus === 'loading'
  let tecnico = store.getters.Tecnico
  let requiresAuth = to.matched.some(r => r.meta.requiresAuth)
  let requiresTecnico = to.matched.some(r => r.meta.requiresTecnico)
  if (requiresAuth && !_currentUser) return next('/login')
  else if (requiresTecnico && !tecnico) return next('/')
  else return next()
})

Router.afterEach((to, from) => {
  let endTime = Date.now()
  let timeDiff = endTime - startTime
  let msDiff = Math.round(timeDiff)
  let maxWait = 250
  msDiff = msDiff >= maxWait ? 1 : maxWait - msDiff
  setTimeout(() => {
    store.dispatch('setInnerLoading', false)
  }, msDiff)
})
export default Router
